import React, { Component } from 'react';
import ListEditor from './ListEditor.js'
import { FormControl, FormGroup } from 'react-bootstrap';

const DEFAULT_REFERENCES = [
    {reference: "", key: 0}
];
class References extends Component {
    render() {
        return (
            <ListEditor
                values={
                    this.props.references ? this.props.references.map((referenceString, index) => {
                        // Map strings to objects. Can maybe push this into ListEditor at some point
                        return {
                            key: index,
                            reference: referenceString
                        };
                    }) : undefined
                }
                defaultValues={DEFAULT_REFERENCES}
                valuesMaxLength={10}
                createListItem={(listItemData) =>
                    <Reference
                        index={listItemData.index}
                        key={listItemData.key}
                        reference={listItemData.value.reference}
                        updateListItem={listItemData.updateListItem} />
                }
                setListItems={(referenceObjects) => {
                    // Map objects back to strings. Can maybe push this into ListEditor at some point
                    this.props.setReferences(referenceObjects.map((referenceObject) =>
                        referenceObject.reference || ""
                    ));
                }}
                validationErrors={this.props.validationErrors}
                addButtonText={"Add reference"}
                headerText={"Reference(s)"}
            />
        )
    }
}

class Reference extends Component {
    constructor(props) {
        super(props);
        this.handleReferenceChange = this.handleReferenceChange.bind(this);
    }
    handleReferenceChange(e) {
        this.props.updateListItem(this.props.index, {reference: e.target.value});
    }
    render() {
        let placeHolderText = "Must be a major textbook for the subject or well-designed study; citations should be in American Medical Association (AMA) format."
        return (
            <FormGroup controlId="reference" className="padded-item">
                <FormControl
                    type="text"
                    value={this.props.reference}
                    placeholder={placeHolderText}
                    onChange={(e) => this.handleReferenceChange(e)}>
                </FormControl>
            </FormGroup>
        )
    }
}

export default References
